import { doAjax } from './helper'
import { initModal } from './modal'
const initModelcategorySelectLogic = () => {
	let submit = document.getElementById('navigation-submit-btn')
	let modelcategorySelector = document.getElementById('modelcategory-select')
	var clickForAudiCode = document.querySelector('.clickForAudiCode');
	var audicodeButton = document.querySelector('.audicodeButton');
	
	submit.setAttribute('disabled', true)

	modelcategorySelector.addEventListener('change', () => {
		submit.removeAttribute('disabled')
	})

	const modal = document.querySelectorAll('.modal')[0]
	initModal(cancelModal, canSubmitModal);

	if (clickForAudiCode) { // open Modal
		clickForAudiCode.addEventListener('click', function () {
			modal.classList.remove("hidden")
			document.getElementById('audicode').disabled = false; // enable input audicode
		});
	}

	function cancelModal() { // close Modal
		document.getElementById('audicode').value = ''; // delete input
		document.getElementById('audicode').disabled = true; // disable input audicode
		document.getElementById('audicodeSelected').disabled = true; // disable input audicodeSelected
		document.getElementById("modalAudiCode").classList.remove("hidden"); // show modalAudiCode
		document.getElementById("modalAudiCodeResponse").classList.add("hidden"); // hide modalAudiCodeResponse
		document.getElementById("audicodeModalNext").classList.add("hidden"); // hide submit button
		//document.getElementById("audicodeModalPrevText").classList.add("aui-prev-special"); // show prev text button
		document.getElementById("modalAudiCodeNote").classList.remove("hidden"); // show invalid
		document.getElementById("modalAudiCodeNote2").classList.add("hidden"); // show invalid
		document.getElementById("modalAudiCode").classList.remove("is-invalid"); // remove invalid
	}

	function canSubmitModal() {  // send Modal
		submit.removeAttribute('disabled');
		submit.click();
	}

	if (audicodeButton) {
		audicodeButton.addEventListener('click', function () {
			let audicode = document.getElementById("audicode").value;
			doAjax({
				'audicode': audicode
			}, (response) => {
				if (response?.apiResponse) {
					if (response.apiResponse) {
						//  make HTML-Code between Divs
						let picureCode = '<img src="'+response.apiResponse.modelPicture+'">';
						let modelCode = 'Audi ' + langArray[response.apiResponse.modelName];

						// select Div-Element
						let audicodeModalSelectedPicture = document.getElementById('audicodeModalSelectedPicture');
						let audicodeModalSelectedModel = document.getElementById('audicodeModalSelectedModel');

						// add HTML-Code between Divs
						audicodeModalSelectedPicture.innerHTML = picureCode;
						audicodeModalSelectedModel.innerHTML = modelCode;
						
						document.getElementById('audicodeSelected').value = audicode; // add audicode to audicodeSelected
						document.getElementById('audicode').disabled = true; // disable input audicode
						document.getElementById('audicodeSelected').disabled = false; // enable input audicodeSelected
						document.getElementById("modalAudiCode").classList.add("hidden"); // hide modalAudiCode
						document.getElementById("modalAudiCodeResponse").classList.remove("hidden"); // show modalAudiCodeResponse
						document.getElementById("audicodeModalNext").classList.remove("hidden"); // show submit button
						//document.getElementById("audicodeModalPrevText").classList.remove("aui-prev-special"); // hide prev text button
						//document.getElementById("modalAudiCode").classList.remove("is-invalid");
					}
				} else if (response?.apiError) {
					if (response.apiError == 'wrongApiResponse') {
						document.getElementById("modalAudiCode").classList.add("is-invalid"); // show invalid 
						document.getElementById("modalAudiCodeNote").classList.add("hidden"); // show invalid
						document.getElementById("modalAudiCodeNote2").classList.remove("hidden"); // show invalid
						//document.getElementById("modalAudiCodeResponse").classList.add("hidden");
						//document.getElementById('audicodeSelected').value = '';
						//document.getElementById('audicode').disabled = true;
					}
				}
			})
		});
	}

}
export { initModelcategorySelectLogic };
